import styled from 'styled-components';

import { borderRadius } from '~/design-tokens/border-radius/borderRadius';
import { typographyV2 } from '~/design-tokens/typography/Typography.styles';
import { timingFunction } from '~/utils/transitions';

export const IconWrapper = styled.span`
  display: flex;

  svg {
    fill: var(--icon-default);
  }
`;

export const MainLabel = styled.span`
  color: var(--text-default);
`;

export const ItemBackground = styled.div`
  ${borderRadius.r1};
  position: absolute;
  inset: 0;
  pointer-events: none;
  width: 100%;
  transition: transform 300ms ${timingFunction.base};
`;

export const SubItem = styled.button<{
  $isActive: boolean;
  $sideBarExpanded: boolean;
}>`
  ${typographyV2.bodySm};
  ${borderRadius.r2};
  position: relative;
  z-index: 1;
  border: none;
  white-space: nowrap;
  cursor: pointer;
  outline: none;
  gap: 8px;
  display: flex;
  align-items: center;
  width: 100%;
  height: auto;
  justify-content: ${({ $sideBarExpanded }) =>
    $sideBarExpanded ? 'flex-start' : 'center'};
  padding: 6px 8px;
  ${borderRadius.r1}
  color: var(--text-default);

  &:hover,
  &:focus-visible {
    background-color: var(--surface-hover);
  }

  background-color: ${({ $isActive }) =>
    $isActive ? 'var(--surface-active)' : 'inherit'};
`;
